export default {
  locale: "fr",
  name: "Fenêtre de Fermeture de Voyage",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Date de début",
      },
      {
        fieldName: "endDate",
        displayName: "Date de fin",
      },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeTravel",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Entrez une date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
